/**
 * BrandName – renders the OG's Garage wordmark logo image inline in place
 * of the workshop-name text. Sizes are boosted to compensate for the
 * whitespace padding in the source PNG.
 */

const BRAND_LOGO =
  "https://customer-assets-0z36b82j.emergentagent.net/job_kfz-scheduler/artifacts/jqaukaob_OG%60s%20Garage.png";

const SIZE_MAP = {
  xs: "h-8 sm:h-10",
  sm: "h-10 sm:h-16 lg:h-20",
  md: "h-24 sm:h-28",
  lg: "h-40 sm:h-48",
  xl: "h-56 sm:h-72 lg:h-80",
};

export default function BrandName({
  name = "OG's Garage",
  size = "md",
  className = "",
  testId = "brand-name",
}) {
  const cls = SIZE_MAP[size] || SIZE_MAP.md;
  return (
    <img
      src={BRAND_LOGO}
      alt={name}
      data-testid={testId}
      className={`inline-block w-auto object-contain ${cls} ${className}`}
      draggable={false}
    />
  );
}
